"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.LINE_ITEM_NOTE_MAX_LENGTH = exports.LINE_ITEM_NOTE_MIN_LENGTH = exports.LINE_ITEM_LINK_MAX_LENGTH = exports.LINE_ITEM_LINK_MIN_LENGTH = exports.LINE_ITEM_QUANTITY_MAX_DECIMAL_PLACES = exports.LINE_ITEM_QUANTITY_RECEIVED_MAX = exports.LINE_ITEM_QUANTITY_RECEIVED_MIN_BIGGER_THAN = exports.LINE_ITEM_MATERIAL_CODE_MAX_LENGTH = exports.LINE_ITEM_MATERIAL_CODE_MIN_LENGTH = exports.LINE_ITEM_NAME_MAX_LENGTH = exports.LINE_ITEM_NAME_MIN_LENGTH = exports.LINE_ITEM_PRICE_MIN_BIGGER_THAN = exports.LINE_ITEM_UNIT_OF_MEASURE_MAX_LENGTH = exports.LINE_ITEM_UNIT_OF_MEASURE_MIN_LENGTH = exports.LINE_ITEM_QUANTITY_MAX = exports.LINE_ITEM_QUANTITY_MIN_BIGGER_THAN = void 0;
const common_1 = require("../../consts/common");
const validators_1 = require("../../utils/validators");
// UNIT
exports.LINE_ITEM_QUANTITY_MIN_BIGGER_THAN = 0;
exports.LINE_ITEM_QUANTITY_MAX = 99999;
exports.LINE_ITEM_UNIT_OF_MEASURE_MIN_LENGTH = 1;
exports.LINE_ITEM_UNIT_OF_MEASURE_MAX_LENGTH = 32;
// PRICE
exports.LINE_ITEM_PRICE_MIN_BIGGER_THAN = common_1.PRICE_MIN_BIGGER_THAN;
// NAME & CODES
exports.LINE_ITEM_NAME_MIN_LENGTH = validators_1.MIN_INPUT_LENGTH;
exports.LINE_ITEM_NAME_MAX_LENGTH = validators_1.MAX_INPUT_LENGTH;
exports.LINE_ITEM_MATERIAL_CODE_MIN_LENGTH = validators_1.MIN_INPUT_LENGTH;
exports.LINE_ITEM_MATERIAL_CODE_MAX_LENGTH = validators_1.MAX_INPUT_LENGTH;
// QUANTITY RECEIVED
exports.LINE_ITEM_QUANTITY_RECEIVED_MIN_BIGGER_THAN = exports.LINE_ITEM_QUANTITY_MIN_BIGGER_THAN;
exports.LINE_ITEM_QUANTITY_RECEIVED_MAX = exports.LINE_ITEM_QUANTITY_MAX;
exports.LINE_ITEM_QUANTITY_MAX_DECIMAL_PLACES = 3;
// LINK & NOTE
exports.LINE_ITEM_LINK_MIN_LENGTH = validators_1.MIN_INPUT_LENGTH;
exports.LINE_ITEM_LINK_MAX_LENGTH = validators_1.MAX_INPUT_LENGTH;
exports.LINE_ITEM_NOTE_MIN_LENGTH = validators_1.MIN_INPUT_LENGTH;
exports.LINE_ITEM_NOTE_MAX_LENGTH = validators_1.MAX_INPUT_LENGTH;
